import QueryString from "query-string";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GOOGLE_PROJECTS_SIDE_MODAL } from "../../../../constants/modal.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useGoogleCore } from "../../../../cores/google";
import { useMeCore } from "../../../../cores/me";
import routes from "../../../../cores/router/routes";
import { useRouterCore } from "../../../../cores/router";
import GoogleCalendarPopUp from "../GoogleCalendar/GoogleCalendarPopUp";
import GoogleDrivePopUp from "../GoogleDrive/GoogleDrivePopUp";

export default function GooglePopUp() {
  const { pathname, search } = useLocation();
  const { getProjects } = useGoogleCore();
  const { company } = useMeCore();
  const { goToSocial } = useRouterCore();
  const { turnOnModal } = useGlobalCore();

  const isDriveCallback = pathname === routes.googleDrivePopUp;
  const isCalendarCallback = pathname === routes.googleCalendarPopUp;

  useEffect(() => {
    if (isDriveCallback || isCalendarCallback) return;
    if (pathname !== routes.googlePopUp) return;

    const { code } = QueryString.parse(search);
    if (code) getProjects(company!.id, code as string);
    goToSocial();
    turnOnModal(GOOGLE_PROJECTS_SIDE_MODAL, true);
  }, [
    pathname,
    search,
    company,
    goToSocial,
    getProjects,
    turnOnModal,
    isDriveCallback,
    isCalendarCallback,
  ]);

  // En builds viejos /social/google matcheaba también calendar y drive.
  if (isDriveCallback) {
    return <GoogleDrivePopUp />;
  }

  if (isCalendarCallback) {
    return <GoogleCalendarPopUp />;
  }

  return <div></div>;
}
